import { SESSION } from '@/constants'

export const GLOBAL_FILTER_MODULE = 'globalFilter';

// STATE
export const state = {
    currentGroup: null,
    reload: true,
};

// ACTIONS
export const SET_GLOBAL_FILTER = 'setGlobalFilter';

// MUTATIONS
const GLOBAL_FILTER_SUCCESS = 'globalFilterSuccess';
const GLOBAL_RELOADING = 'globalReloading';

export const actions = {
    [SET_GLOBAL_FILTER]({ commit }, data) {
        commit(GLOBAL_FILTER_SUCCESS, {data});
        commit(GLOBAL_RELOADING);
    },
};

export const mutations = {
    [GLOBAL_FILTER_SUCCESS](state, {data}) {
        state.currentGroup = data;
        localStorage.setItem(SESSION.GLOBAL_FILTER, data);
    },
    [GLOBAL_RELOADING](state) {
        state.reload = !state.reload;
    },
};